export default "__VITE_ASSET__04abbc11__"